var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-admin"},[_c('div',{staticClass:"app-admin__header"},[_vm._v(" MEBUKi Admins ")]),_c('div',{staticClass:"app-admin__body"},[_c('div',{staticClass:"app-admin__main"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }